import React, { useState, useEffect } from 'react';
import RobotaxiLogin from '../../Images/LoginImage.png';
import { Link } from 'react-router-dom';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Typography from '@mui/material/Typography';
import axios from 'axios';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import PhoneInput from 'react-phone-number-input';
import '../../globalStyles/styles.css';
import { digitsWithAlphabetsRegex } from '../utils/regexPatterns'
import ValidationMessages from "../utils/validationMessages";
import termsOfServicesData from '../TermsOfServices/TermsOfServices.json';
import termsOfUsesData from '../TermsOfServices/TermsOfUses.json'
import BootstrapDialog1 from '../BootstrapDialog/BootstrapDialog.jsx';


const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    "& .MuiDialogContent-root": {
        padding: theme.spacing(2),
    },
    "& .MuiDialogActions-root": {
        padding: theme.spacing(1),
    },
}));

const EntityInformation = (props) => {
    const { overrides, setIsFlagSet, isFlagSet, formData, setFormData, ...rest } = props;   
    const [rangeValue, setRangeValue] = useState(30);
    const [open, setOpen] = React.useState(false);
    const [openTerms, setOpenTerms] = React.useState(false);
    const [states, setStates] = useState([]);
    const [cities, setCities] = useState([]);
    const [errors, setErrors] = useState({});
    const [,setEmail] = useState("");    
    const [,setSelectedValue] = useState("");
    const [searchValue, setSearchValue] = useState("");
    const [suggestions, setSuggestions] = useState([]);    
    const [mailingAddressZipCode, setMailingAddressZipCode] = useState("");
    const [zipcodeWarning, setZipcodeWarning] = useState("");
    const [mailingAddressCity, setMailingAddressCity] = useState("");
    const envname = process.env.REACT_APP_ENV_TXT || null;
    const [dialogData, setDialogData] = useState({ title: '', sections: [] });
    const todayDate = new Date();
    const hostPath = process.env.REACT_APP_API_BASE_URL;

    useEffect(() => {
        if (formData.StateId) {
            fetchCities(formData.StateId);
        }
    }, [formData.StateId]);

    useEffect(() => {
        if (formData.CityId) {
            setMailingAddressCity(formData.CityId);
        }
    }, [formData.CityId]);

    useEffect(() => {
        const fetchStates = async () => {
            try {
                 const response = await axios.get(`${hostPath}/api/GetUSStates`, {
                 });
                var data = response.data.filter((country) =>
                    /^[a-zA-Z0-9]+$/.test(country.iso2)
                );
                // Sort the states alphabetically by name
                data.sort((a, b) => a.name.localeCompare(b.name));
                setStates(data);
            } catch (error) {
                console.error("Error fetching states:", error);
            }
        };

        fetchStates();
    }, []);

    useEffect(() => {
        if (searchValue?.trim() !== "") {
            // Fetch suggestions from API
            axios
                .get(
                    `https://atlas.microsoft.com/search/address/json?&subscription-key=iKSTDEFy2eA9QfhSETwDwwnQoR_36iCV5wv18ubSOBw&api-version=1.0&language=en-US&query=${searchValue}&filter=countryCode=US`
                )
                .then((response) => {
                    const results = response.data.results;
                    if (results && results.length > 0) {
                        // Extract suggestion labels from response and update state
                        const suggestedLocations = results
                            .filter((result) => result.address.countryCode === "US" && result.address.streetNumber)
                            .map((result) => result.address);
                        setSuggestions(suggestedLocations);
                    }
                })
                .catch((error) => {
                    console.error("Error fetching location suggestions:", error);
                });
        } else {
            setSuggestions([]);
        }
    }, [searchValue]);

    const handleSearchChange = (e) => {
        const { name, value } = e.target;
        if (name === "EnityMailingAdderess") {
            if (name) {
                errors.EnityMailingAdderess = "";
                setFormData({ ...formData, [name]: value });
            } else {
                errors.EnityMailingAdderess = ValidationMessages.mailingaddressrequired;
            }
        }
        setSearchValue(e.target.value);
    };

    const handleAddressSelect = (address) => {
        const selectedState = states.find(
            (state) =>
                state.name.toLowerCase() ===
                address?.countrySubdivisionName?.toLowerCase()
        );
        var selectedCity;        
        setMailingAddressZipCode(address?.postalCode ? address?.postalCode : "");
        setMailingAddressCity(address?.municipality);
        errors.CityId = "";
        errors.Zipcode = "";
        setZipcodeWarning("");
        if (selectedState) {
            fetchCities(selectedState.iso2).then((citylist) => {
                selectedCity = citylist?.find(
                    (city) =>
                        city.name.toLowerCase() === address?.municipality?.toLowerCase()
                );
                setFormData((prevState) => ({
                    ...prevState,
                    CityId: selectedCity ? selectedCity.name : address?.municipality || "",
                }));
            });
        }
        // Split the address by comma and select the first part
        const shortAddress = address?.freeformAddress;
        setFormData((prevState) => ({
            ...prevState,
            EnityMailingAdderess: shortAddress, // Update with the short address
            Zipcode: address?.postalCode ? address?.postalCode : "",
            StateId: selectedState ? selectedState.iso2 : "",
        }));
        setSearchValue("");
        setSuggestions([]);
    };
    const handleAddressValidation = async (value) => {
        try {
            const response = await axios.get(
                `https://atlas.microsoft.com/search/address/json?&subscription-key=EN5vcaicwC78zKi3M3980VVB1m7DuuN0vKaDMtYdjBg7daKhx3OTJQQJ99AHAC8vTIngVrqvAAAgAZMPLtXG&api-version=1.0&language=en-US&query=${value}&countrySet=US`
            );
            const results = response.data.results || [];
            const exactMatch = results.find(
                (result) => result.address.countryCode === 'US' &&
                    result.address.freeformAddress === value.trim()
            );
            if (exactMatch) {
                return true;
            } else {
                return false;

            }

        } catch (error) {
            console.error("Error fetching address suggestions:", error);
        }
    };

    const handleContinue = (e) => {
        e.preventDefault();
        if (!props.settingpage) {
            setOpen(false);
            props.sendOTPByPhone({ MobileNumber: props.formData?.MobileNumber })
        }
    };

    const fetchCities = async (data) => {
        try {
            const response = await axios.post(`${hostPath}/api/GetCitiesByState`, {stateId:data});
            setCities(response.data);
            return response.data;
        } catch (error) {
            return [];
        }
    };

    const validateForm1 = async () => {
        const errors = {};
        const extendedAlphaNumericRegex = /^[a-zA-Z0-9À-ÿ\s\-,&.]*$/;
        const digitRegex = /^\d*$/;

        if (!formData.EntityName) {
            errors.EntityName = ValidationMessages.entityName;
        } else if (!extendedAlphaNumericRegex.test(formData.EntityName)) {
            errors.EntityName = ValidationMessages.entityNameConstraints;
        } else if (!digitsWithAlphabetsRegex.test(formData.EntityName) && formData.EntityName !== "") {
            errors.EntityName = ValidationMessages.entitydigits;
        }
        const isaddressvalid = await handleAddressValidation(formData.EnityMailingAdderess);
        if (!isaddressvalid) {
            errors.EnityMailingAdderess = ValidationMessages.entitymailingadd;
        }
        if (!formData.EnityMailingAdderess) {
            errors.EnityMailingAdderess = ValidationMessages.mailingaddressrequired;
        }
        if (!formData.Country) {
            errors.Country = ValidationMessages.countryRequired;
        }
        if (!formData.StateId) {
            errors.StateId = ValidationMessages.statereq;
        }
        if (!formData.CityId) {
            errors.CityId = ValidationMessages.cityReq;
        }
        if (formData.CityId !== mailingAddressCity) {
            errors.CityId = ValidationMessages.cityMatch
        }
        if (!formData.Zipcode) {
            errors.Zipcode = ValidationMessages.zipReq;
        } else if (!digitRegex.test(formData.Zipcode)) {
            errors.Zipcode = ValidationMessages.zipCodeDigits;
        } else if (formData.Zipcode.length > 5 || formData.Zipcode.length < 5) {
            errors.Zipcode = ValidationMessages.zipCode5;
        } else if (mailingAddressZipCode !== formData.Zipcode && mailingAddressZipCode !== "" && mailingAddressZipCode !== "") {
            setZipcodeWarning("");
            errors.Zipcode = ValidationMessages.zipCodeAddreess;
        }

        setErrors(errors);
        return Object.keys(errors).length === 0;
    };

    const validateForm2 = async () => {
        const errors = {};
        const alphabetRegex = /^[A-Za-z\s\'']*$/;
        if (!formData.FirstName) {
            errors.FirstName = ValidationMessages.firstNameRequired;
        } else if (!alphabetRegex.test(formData.FirstName)) {
            errors.FirstName = ValidationMessages.firstNameAlphabets;
        }

        if (!formData.LastName) {
            errors.LastName = ValidationMessages.lastNameRequired;
        } else if (!alphabetRegex.test(formData.LastName)) {
            errors.LastName = ValidationMessages.lastNameAlphabets;
        }

        if (!formData.title) {
            errors.title = ValidationMessages.titleRequired;
        } else if (!alphabetRegex.test(formData.title)) {
            errors.title = ValidationMessages.titleAlphabets;
        }

        if (!formData.MobileNumber) {
            errors.MobileNumber = ValidationMessages.phoneRequired;
        } else {
            const phoneNumber = formData.MobileNumber.replace(/\D/g, "");
            if (phoneNumber.length !== 11 || !phoneNumber.startsWith("1")) {
                errors.MobileNumber = ValidationMessages.inValidPhone;
            }
        }
        if (!formData.OfficeNumber) {
            // errors.OfficeNumber = "Mobile Number is required";
        } else {
            const OfficeNumber = formData.OfficeNumber.replace(/\D/g, "");
            if (OfficeNumber.length !== 11 || !OfficeNumber.startsWith("1")) {
                errors.OfficeNumber = ValidationMessages.OfficePhone;
            }
        }
        if (!formData.TandC2) {
            errors.TandC2 = "Please agree to the Terms of Use.";
        }

        if (!formData.TandC) {
            errors.TandC = "Please agree to the Terms of Service.";
        }
        setErrors(errors);
        return Object.keys(errors).length === 0;
    };    
    const handleButtonClick = async (e) => {
        e.preventDefault();
        const validate = await validateForm1();
        if (validate) {
            setIsFlagSet(true);
            setRangeValue(60);
        }
    };

    const goback = (e) => {
        e.preventDefault();
        setIsFlagSet(false);
        setRangeValue(30);
    };

    const registrationButtonClick = async (e) => {
        e.preventDefault();
        if (await validateForm2()) {
            try {
                setOpen(true);
            } catch (error) {
                console.error("Error checking email existence:", error.message);
                setErrors({ ...errors, EmailId: "Email already exists" });
            }
        }
    };
    

    const handleChange = (e) => {
        const { name, value } = e.target;
        const alphabetRegex = /^[A-Za-z\s\'']*$/;
        const extendedAlphaNumericRegex = /^[a-zA-Z0-9À-ÿ\s\-,.&]*$/;
        const digitRegex = /^\d*$/;
        if (name === "EntityName") {
            if (!extendedAlphaNumericRegex.test(value) && value !== "") {
                errors.EntityName = ValidationMessages.entityNameConstraints;
            }
            else if (/^&+$/.test(value)) {
                errors.EntityName = ValidationMessages.entitycon;
            }
            else if (/^\.+$/.test(value)) {
                errors.EntityName = ValidationMessages.entitydots;
            }
            else if (!digitsWithAlphabetsRegex.test(value)) {
                errors.EntityName = ValidationMessages.entitydigits;
            } else {
                errors.EntityName = "";
            }
            setFormData({ ...formData, [name]: value });
        }
        if (name === "Zipcode") {
            if (!digitRegex.test(value)) {
                errors.Zipcode = ValidationMessages.zipCodeDigits;
            } else if ((value.length > 5 || value.length < 5) && value !== "") {
                errors.Zipcode = ValidationMessages.zipCode5;
            } else if (mailingAddressZipCode !== value && mailingAddressZipCode !== "" && value !== "") {
                setZipcodeWarning(ValidationMessages.zipCodeAddreess);
                errors.Zipcode = "";
            }
            else {
                errors.Zipcode = "";
                setZipcodeWarning("");
            }
            setFormData({ ...formData, [name]: value });
        }

        if (name === "FirstName") {
            if (!alphabetRegex.test(value)) {
                errors.FirstName = ValidationMessages.firstNameAlphabets;
            } else {
                errors.FirstName = "";
                setFormData({ ...formData, [name]: value });
            }
        }

        if (name === "LastName") {
            if (!alphabetRegex.test(value)) {
                errors.LastName = ValidationMessages.lastNameAlphabets;
            } else {
                errors.LastName = "";
                setFormData({ ...formData, [name]: value });
            }
        }
        if (name === "title") {
            if (!alphabetRegex.test(value)) {
                errors.title = ValidationMessages.titleAlphabets;
            } else {
                errors.title = "";
                setFormData({ ...formData, [name]: value });
            }
        }

        if (name === "EmailId") {
            if (!/\S+@\S+\.\S+/.test(value)) {
                errors.EmailId = ValidationMessages.emailInvalid;
            }
            else {
                errors.EmailId = "";
                setEmail((prev) => value);
                setFormData({ ...formData, [name]: value });
            }
        }

        if (name === "MobileNumber") {
            setFormData({ ...formData, [name]: value });
            setErrors({ ...errors, MobileNumber: "" })
        }

        else if (name === "OfficeNumber") {
            setFormData({ ...formData, [name]: value });
            setErrors({ ...errors, OfficeNumber: "" })
        }
        else {
            setFormData((prevState) => ({
                ...prevState,
                [name]: value,
            }));
        }
    };

    const stateChange = (e) => {
        const { name, value } = e.target;
        if (value) {
            fetchCities(value);
        }
        if (name === 'StateId') {
            setFormData({ ...formData, [name]: value });
            errors.StateId = '';
        }
        else {
            errors.StateId = ValidationMessages.statereq;
        }
    };
    const cityChange = (e) => {
        const { name, value } = e.target;
        if (value) {
            fetchCities(value);
        }
        if (name === 'CityId') {
            let errorMessage = '';
            if (value && value !== mailingAddressCity) {
                errorMessage = ValidationMessages.cityMatch;
            }

            setFormData({ ...formData, [name]: value });
            setErrors({ ...errors, CityId: errorMessage });
        }
    };
   
    const handleCloseterms = () => {
        setOpenTerms(false);
        setSelectedValue("");
    }

    const handleClose = () => {
        setOpen(false);
        setSelectedValue("");
    };
    const handleCheckboxChange2 = () => {
        setFormData(prevState => ({
            ...prevState,
            TandC2: !prevState.TandC2,
        }));
        setErrors(prevErrors => ({
            ...prevErrors,
            TandC2: "", // Clear the error immediately when checked
        }));
    };

    const handleCheckboxChange = () => {
        setFormData(prevState => ({
            ...prevState,
            TandC: !prevState.TandC,
        }));
        setErrors(prevErrors => ({
            ...prevErrors,
            TandC: "", // Clear the error immediately when checked
        }));
    };

    const handleClickOpen = (type) => {
        let item;
        if (type === 'termsOfServices') {
            item = termsOfServicesData.termsOfServices[0];
        } else if (type === 'termsOfUses') {
            item = termsOfUsesData.termsOfUses[0];
        }
        if (item) {
            setDialogData(item);
            setOpenTerms(true)
        } else {
            console.error("No data found.");
        }
    };


    return (
        <div className="container-fluid p-0 entity">
            <div className="row m-0">
                <div className="col-md-6 p-0">
                    <img src={RobotaxiLogin} alt="Login" className="GeoparkingImage" />
                </div>
                <div className="col-md-6 p-0 mb-3">
                    <div className="contain">
                        <div className="registersteps"> Step {isFlagSet ? 2 : 1} of 3</div>
                        <input
                            type="range"
                            className="range-input mb-3"
                            value={rangeValue}
                            min="0"
                            max="100"
                            style={{
                                width: "80%",
                                height: "5px",
                                padding: "0",
                                borderRadius: "5.5px",
                                background: `linear-gradient(to right, green ${rangeValue}%, lightgray ${rangeValue}%)`,
                                outline: "none",
                            }}
                        />

                        <div className="login-form">
                            <div className="login">
                                {envname && <span className="restricted-badge">{envname}</span>}
                                <h3 className="loginheader textleft">Entity Information</h3>
                                <p className="mb-4 loginDescription textleft">
                                    Please provide the Parking Lot(s) owner/management entity
                                    information
                                </p>
                            </div>

                            {isFlagSet ? (
                                <form onSubmit={registrationButtonClick}>
                                    <div className="Username mb-2 textleft">
                                        <label
                                            htmlFor="first-name"
                                            className="userName loginlabel "
                                        >
                                            First Name
                                        </label>
                                        <span className="mandatorymark loginlabel">*</span>
                                        <input
                                            type="text"
                                            className={`form-control ${formData.FirstName ? "input-active" : ""
                                                }`}
                                            id="first-name"
                                            maxLength={50}
                                            placeholder="Enter First Name"
                                            name="FirstName"
                                            value={formData.FirstName}
                                            onChange={handleChange}
                                        />
                                        {errors.FirstName && (
                                            <div className="error-message mandatorymark">
                                                {errors.FirstName}
                                            </div>
                                        )}
                                    </div>
                                    <div className="Password mb-2 textleft">
                                        <label htmlFor="last-name" className="userName loginlabel">
                                            Last Name
                                        </label>
                                        <span className="mandatorymark loginlabel">*</span>
                                        <input
                                            type="text"
                                            className={`form-control ${formData.LastName ? "input-active" : ""
                                                }`}
                                            id="last-name"
                                            maxLength={50}
                                            placeholder="Enter Last Name "
                                            name="LastName"
                                            value={formData.LastName}
                                            onChange={handleChange}
                                        />
                                        {errors.LastName && (
                                            <div className="error-message mandatorymark">
                                                {errors.LastName}
                                            </div>
                                        )}
                                    </div>
                                    <div className="Password mb-2 textleft">
                                        <label htmlFor="title" className="userName loginlabel">
                                            Title
                                        </label>
                                        <span className="mandatorymark loginlabel">*</span>
                                        <input
                                            type="text"
                                            className={`form-control ${formData.title ? "input-active" : ""
                                                }`}
                                            id="title"
                                            maxLength={50}
                                            placeholder="Enter Title "
                                            name="title"
                                            value={formData.title}
                                            onChange={handleChange}
                                        />
                                        {errors.title && (
                                            <div className="error-message mandatorymark">
                                                {errors.title}
                                            </div>
                                        )}
                                    </div>
                                    <div className="Password mb-2 textleft">
                                        <label
                                            htmlFor="MobileNumber"
                                            className="userName loginlabel"
                                        >
                                            Mobile Phone
                                        </label>
                                        <span className="mandatorymark loginlabel">*</span>
                                        <PhoneInput
                                            international
                                            countryCallingCodeEditable={false}
                                            name="MobileNumber"
                                            maxLength={15}
                                            value={formData.MobileNumber}
                                            id="MobileNumber"
                                            placeholder="Enter phone number"
                                            defaultCountry='US'
                                            countries={['US']}
                                            onChange={(value) => handleChange({ target: { name: "MobileNumber", value } })}
                                            className="small-phone-input" />
                                        {errors.MobileNumber && (
                                            <div className="error-message mandatorymark">
                                                {errors.MobileNumber}
                                            </div>
                                        )}
                                    </div>
                                    <div className="Password mb-2 textleft">
                                        <label
                                            htmlFor="MobileNumber"
                                            className="userName loginlabel"
                                        >
                                            Office Phone
                                        </label>
                                        <PhoneInput
                                            international
                                            countryCallingCodeEditable={false}
                                            name="OfficeNumber"
                                            maxLength={15}
                                            value={formData.OfficeNumber}
                                            id="OfficeNumber"
                                            placeholder="Enter office number"
                                            defaultCountry='US'
                                            countries={['US']}
                                            onChange={(value) => handleChange({ target: { name: "OfficeNumber", value } })}
                                            className="small-phone-input" />
                                        {errors.OfficeNumber && (
                                            <div className="error-message mandatorymark">
                                                {errors.OfficeNumber}
                                            </div>
                                        )}
                                    </div>

                                    <div className="termsrow">
                                        {/* Terms of Use */}
                                        <div className="termsitem">
                                            <label className="control control--checkbox mb-0">
                                                <input
                                                    type="checkbox"
                                                    checked={formData.TandC2}
                                                    onChange={handleCheckboxChange2}
                                                />
                                                <span className="checkbox-label">
                                                    I Agree to
                                                    <a
                                                        className="joingeo"
                                                        href="#"
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            handleClickOpen("termsOfUses");
                                                        }}
                                                    >
                                                        Terms of Use
                                                    </a>
                                                </span>
                                                <div className="control__indicator"></div>
                                            </label>
                                            {/* Move error inside a wrapper */}
                                            {errors.TandC2 && (
                                                <div className="error-message mandatorymark">{errors.TandC2}</div>
                                            )}
                                            {formData.TandC2 &&
                                                <>
                                                    <label>Checked by: {formData.FirstName} {formData.LastName}</label>
                                                    <label>
                                                        Date:&nbsp;
                                                        {todayDate instanceof Date
                                                            && `${String(todayDate.getMonth() + 1).padStart(2, '0')}/${String(todayDate.getDate()).padStart(2, '0')}/${todayDate.getFullYear()}`
                                                        }

                                                    </label>
                                                </>
                                            }
                                        </div>

                                        {/* Terms of Service */}
                                        <div className="termsitem">
                                            <label className="control control--checkbox mb-0">
                                                <input
                                                    type="checkbox"
                                                    checked={formData.TandC}
                                                    onChange={handleCheckboxChange}
                                                />
                                                <span className="checkbox-label">
                                                    I Agree to
                                                    <a
                                                        className="joingeo"
                                                        href="#"
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            handleClickOpen("termsOfServices");
                                                        }}
                                                    >
                                                        Terms of Service
                                                    </a>
                                                </span>
                                                <div className="control__indicator"></div>
                                            </label>
                                            {/* Move error inside a wrapper */}
                                            {errors.TandC && (
                                                <div className="error-message mandatorymark">{errors.TandC}</div>
                                            )}{
                                                formData.TandC &&
                                                <>
                                                    <label>Checked by: {formData.FirstName} {formData.LastName}</label>
                                                    <label>
                                                        Date:&nbsp;
                                                        {todayDate instanceof Date
                                                            && `${String(todayDate.getMonth() + 1).padStart(2, '0')}/${String(todayDate.getDate()).padStart(2, '0')}/${todayDate.getFullYear()}`
                                                        }

                                                    </label>
                                                </>
                                            }
                                        </div>
                                    </div>


                                    <div
                                        className=" mb-3 d-flex justify-content-between "
                                        style={{ textAlign: "end" }}
                                    >
                                        <Link
                                            to="/entityinformation"
                                            className="joingeo"
                                            onClick={goback}
                                        >
                                            Go Back
                                        </Link>
                                        <button type="submit" className="nextBtn">
                                            Next
                                        </button>
                                    </div>
                                    <div className="joinus remember" style={{ textAlign: "end" }}>
                                        Already have an account?
                                        <a href="/login" className="joingeo">
                                            {" "}
                                            Log in
                                        </a>{" "}
                                        here.
                                    </div>
                                </form>
                            ) : (
                                <form onSubmit={handleButtonClick}>
                                    <div className="Username mb-2 textleft">
                                        <label htmlFor="username" className="userName loginlabel ">
                                            Entity Name
                                        </label>
                                        <span className="mandatorymark loginlabel">*</span>
                                        <input
                                            type="text"
                                            className={`form-control ${formData.EntityName ? "input-active" : ""
                                                }`}
                                            id="username"
                                            maxLength={50}
                                            name="EntityName"
                                            value={formData.EntityName}
                                            onChange={handleChange}
                                            placeholder="Enter Entity Name"
                                        />
                                        {errors.EntityName && (
                                            <div className="error-message mandatorymark">
                                                {errors.EntityName}
                                            </div>
                                        )}
                                    </div>
                                    <div className="Password mb-2 textleft">
                                        <label htmlFor="password" className="userName loginlabel">
                                            Entity Mailing address
                                        </label>
                                        <span className="mandatorymark loginlabel">*</span>
                                        <input
                                            type="text"
                                            className={`form-control ${formData.EnityMailingAdderess ? "input-active" : ""
                                                }`}
                                            id="password"
                                            maxLength={100}
                                            placeholder="Enter address "
                                            name="EnityMailingAdderess"
                                            value={formData.EnityMailingAdderess}
                                            onChange={(e) => {
                                                handleSearchChange(e);
                                            }}
                                            autoComplete="new-password"
                                        />
                                        {suggestions.length > 0 && (
                                            <ul className="search-results">
                                                {suggestions.map((result) => (
                                                    <li onClick={() => handleAddressSelect(result)}>
                                                        {result.freeformAddress}
                                                    </li>
                                                ))}
                                            </ul>
                                        )}
                                        {errors.EnityMailingAdderess && (
                                            <div className="error-message mandatorymark">
                                                {errors.EnityMailingAdderess}
                                            </div>
                                        )}
                                    </div>
                                    <div className="Password mb-2 textleft">
                                        <label htmlFor="password" className="userName loginlabel">
                                            Entity Mailing address 2 (optional)
                                        </label>
                                        <input
                                            type="text"
                                            className={`form-control ${formData.EnityMailingAdderess2 ? "input-active" : ""
                                                }`}
                                            id="password"
                                            maxLength={50}
                                            placeholder="Enter address"
                                            name="EnityMailingAdderess2"
                                            value={formData.EnityMailingAdderess2}
                                            onChange={handleChange}
                                        />
                                        {/* {errors.UserName && <div className="error-message mandatorymark">{errors.UserName}</div>} */}
                                    </div>
                                    <div className="row ">
                                        <div className="col-md-6 Password mb-2 textleft">
                                            <label htmlFor="password" className="userName loginlabel">
                                                Country
                                            </label>
                                            <span className="mandatorymark loginlabel">*</span>
                                            <input
                                                type="text"
                                                className={`form-control ${formData.Country ? "input-active" : ""
                                                    }`}
                                                id="password"
                                                placeholder="Enter Country "
                                                name="Country"
                                                disabled={true}
                                                value={formData.Country}
                                                onChange={handleChange}
                                                readOnly
                                                style={{ cursor: "not-allowed" }}
                                            />
                                            {errors.Country && (
                                                <div className="error-message mandatorymark">
                                                    {errors.Country}
                                                </div>
                                            )}
                                        </div>
                                        <div className=" col-md-6 Password mb-2 textleft">
                                            <label htmlFor="password" className="userName loginlabel">
                                                State
                                            </label>
                                            <span className="mandatorymark loginlabel">*</span>
                                            <select
                                                className={`form-control ${formData.StateId ? "input-active" : ""
                                                    }`}
                                                id="state"
                                                name="StateId"
                                                value={formData.StateId}
                                                onChange={stateChange}
                                                disabled={true}
                                                style={{ cursor: "not-allowed" }}
                                            >
                                                <option value="">Select State</option>
                                                {states.map((state) => (
                                                    <option key={state.id} value={state.iso2}>
                                                        {state.name}
                                                    </option>
                                                ))}
                                            </select>
                                            {errors.StateId && (
                                                <div className="error-message mandatorymark">
                                                    {errors.StateId}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                    <div className="row ">
                                        <div className=" col-md-6 Password mb-3 textleft">
                                            <label htmlFor="password" className="userName loginlabel">
                                                City
                                            </label>
                                            <span className="mandatorymark loginlabel">*</span>
                                            <select
                                                className={`form-control ${formData.CityId ? "input-active" : ""
                                                    }`}
                                                id="city"
                                                name="CityId"
                                                value={formData.CityId}
                                                onChange={cityChange}
                                                disabled={true}
                                                style={{ cursor: "not-allowed" }}

                                            >
                                                <option value="">Select City</option>
                                                {cities.map((city) => ( 
                                                    <option key={city.id} value={city.iso2}>
                                                        {city.name}
                                                    </option>
                                                ))}
                                                {!cities.some((city) => city.iso2 === formData.CityId) && formData.CityId && (
                                                    <option value={formData.CityId}>{formData.CityId}</option>
                                                )}
                                            </select>
                                            {errors.CityId && (
                                                <div className="error-message mandatorymark">
                                                    {errors.CityId}
                                                </div>
                                            )}
                                        </div>
                                        <div className=" col-md-6 Password mb-2 textleft">
                                            <label htmlFor="password" className="userName loginlabel">
                                                ZIP Code
                                            </label>
                                            <span className="mandatorymark loginlabel">*</span>
                                            <input
                                                type="text"
                                                maxLength="5"
                                                className={`form-control ${formData.Zipcode ? "input-active" : ""
                                                    }`}
                                                id="password"
                                                placeholder="Enter ZIP Code "
                                                name="Zipcode"
                                                value={formData.Zipcode}
                                                onChange={handleChange}
                                                disabled={true}
                                                style={{ cursor: "not-allowed" }}

                                            />
                                            {errors.Zipcode && (
                                                <div className="error-message mandatorymark">
                                                    {errors.Zipcode}
                                                </div>
                                            )}
                                            {zipcodeWarning && (
                                                <div className="error-message mandatorymark">
                                                    {zipcodeWarning}
                                                </div>
                                            )}
                                        </div>
                                    </div>

                                    <div className=" mb-3" style={{ textAlign: "end" }}>
                                        <button type="submit" className='nextBtn'>Next</button>
                                    </div>
                                    <div className='joinus remember' style={{ textAlign: "end" }}>
                                        Already have an account?
                                        <a href='/Login' className='joingeo'> Log in</a> here.</div>
                                </form>
                            )

                            }

                        </div>
                    </div>
                </div>
            </div>
            <BootstrapDialog1
                open={openTerms}
                onClose={handleCloseterms}
                title={`${dialogData.title}`}
                content={dialogData.sections}
                lastModified={`${dialogData.lastModified}`}
                setOpen={setOpenTerms}
            />
            <BootstrapDialog
                onClose={handleContinue}
                classes={{ paper: 'custom-paper-class' }}
                aria-labelledby="customized-dialog-title"

                dividers sx={{
                    textAlign: 'start',
                    overflowY: 'auto',
                    padding: '5rem 5rem',
                    borderRadius: '5px'
                }}
                open={open}
            >
                <DialogTitle dividers sx={{ textAlign: 'start', color: 'rgba(51, 51, 51, 1)', fontSize: "24px", fontWeight: "700", marginLeft: "20px" }} id="customized-dialog-title">
                    Email and Phone Verification
                </DialogTitle>

                <IconButton
                    aria-label="close"
                    onClick={handleClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>

                <DialogContent style={{ border: "none", padding: "12px 37px" }}>
                    <Typography gutterBottom>
                    </Typography>
                    <div>
                    </div>
                    <Typography gutterBottom>
                        <span>
                            Step 1. <strong>Phone Verification:</strong> You will receive a verification code on your registered phone number: {formData?.MobileNumber}.<br />
                            Step 2. <strong>Email Verification & Password Setup:</strong>Popup will prompt you to verify your email and set your password.
                        </span>
                    </Typography>
                </DialogContent>

                <DialogActions sx={{ justifyContent: 'center' }}>
                    <Button
                        className='mb-3'
                        autoFocus
                        classes={{ root: 'Secondary' }}
                        onClick={handleClose}
                        sx={{ width: '150px', height: '50px', backgroundColor: 'lightgrey', color: '#000', fontFamily: 'Montserrat', fontSize: '17px', fontStyle: 'normal', fontWeight: 700, '&:hover': { backgroundColor: '#A9A9A9' } }}
                    >
                        <span style={{ textTransform: 'capitalize' }}>Cancel</span>
                    </Button>
                    <Button
                        className='mb-3'
                        autoFocus
                        onClick={handleContinue}
                        classes={{ root: 'Secondary' }}
                        sx={{ width: '150px', height: '50px', backgroundColor: '#6BCD55', color: '#000', fontFamily: 'Montserrat', fontSize: '17px', fontStyle: 'normal', fontWeight: 700, '&:hover': { backgroundColor: '#5aa949' } }}
                    // disabled={!selectedValue}
                    >
                        <span style={{ textTransform: 'capitalize' }}>Continue</span>
                    </Button>
                </DialogActions>
            </BootstrapDialog>

        </div>
    );
};

export default EntityInformation;
